<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 15:31:31
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\PublicHoliday\viewPublicHoliday.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    backgroundClass="white"
    :delBtn="hasBtn('delete-admin-public-holiday')"
    :title="
      iSEdited
        ? $t('label_essweb_holiday_form_editTitle')
        : $t('label_essweb_holiday_form_viewTitle')
    "
    :initData="HolidayData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['holiday_name', 'holiday_abbr', 'holiday_utc_date', 'remarks']"
    :editBtn="!iSEdited && hasBtn('edit-admin-public-holiday')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_holiday_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="HolidayData.holiday_name"
              @change="
                (valueArr) => {
                  HolidayData.holiday_name = valueArr;
                }
              "
              :label="$t('label_essweb_holiday_form_publicHolidayNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="HolidayData.holiday_abbr"
              @change="
                (valueArr) => {
                  HolidayData.holiday_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_holiday_form_publicHolidayAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="date"
              :filled="iSEdited"
              :defaultTime="HolidayData.holiday_utc_date"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_holiday_form_publicHolidayDateLabel')"
              @change="(time) => (HolidayData.holiday_utc_date = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_holiday_form_publicHolidayTimeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              :filled="iSEdited"
              :readonly="!iSEdited"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="HolidayData.holiday_time_zone"
              dense
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :placeholder="
                $t('label_essweb_holiday_form_publicHolidayTimeZoneLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_holiday_form_publicHolidayRemarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              :filled="iSEdited"
              single-line
              :readonly="!iSEdited"
              dense
              v-model="HolidayData.remarks"
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- toots -->
    <template v-slot:tools-main> </template>
    <!-- toots -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editPublicHoliday",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  data() {
    return {
      iSEdited: false,
      isChanged: false,
      HolidayData: {
        holiday_name: "",
        holiday_abbr: "",
        holiday_utc_date: "",
        holiday_time_zone: 0,
        year: "",
        remarks: "",
      },
    };
  },
  mounted() {
    this.HolidayData.holiday_time_zone = this.defaultUTC;
    this.getBtnPermissionList();
    this.getHolidayDetail();
  },
  methods: {
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getHolidayDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getHolidayDetail();
        } else {
          this.$router.back();
        }
      }
    },
    getHolidayDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/get-holiday-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["holiday_name_save"] = res.data.holiday_name;
        res.data.holiday_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.holiday_name
        );
        res.data["holiday_abbr_save"] = res.data.holiday_abbr;
        res.data.holiday_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.holiday_abbr
        );
        res.data.holiday_utc_date = that.$getDateTime(
          res.data.holiday_utc_date,
          "YYYY-MM-DD"
        );
        res.data["year"] = this.$getDateTime(
          this.$getTimeValue(res.data.holiday_utc_date),
          "YYYY"
        );
        that.HolidayData = res.data;
      });
    },

    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/update-holiday-table/",
        data: {
          uuid: this.$route.params.id,
          holiday_name: this.$transCommonLangKey(
            this.HolidayData.holiday_name,
            this.HolidayData.holiday_name_save
          ),
          holiday_abbr: this.$transCommonLangKey(
            this.HolidayData.holiday_abbr,
            this.HolidayData.holiday_abbr_save
          ),
          holiday_utc_date: this.$getTimeValue(
            this.HolidayData.holiday_utc_date
          ),
          year: this.$getDateTime(
            this.$getTimeValue(this.HolidayData.holiday_utc_date),
            "YYYY"
          ),
          // holiday_time_zone: this.HolidayData.holiday_time_zone,
          remarks: this.HolidayData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_holiday_list_updateHolidaySuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/delete-holiday-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_holiday_list_deleteHolidaySuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
